// Interface-only translations. Scenario text, transcripts and saved assessments
// remain the original English data; this module never rewrites practice content.
export const UI_LANGUAGE_KEY = 'charlie-charlie.ui-language';
export const SUPPORTED_LANGUAGES = ['en', 'zh-Hant'];
const zh = {
  'Your sign-in attempt expired. Enter your teacher’s code and sign in again.': '登入要求已過期，請重新輸入導師派發的代碼，再登入。',
  'Google sign-in could not be completed. Enter your teacher’s code and sign in again.': '未能完成 Google 登入，請重新輸入導師派發的代碼，再登入。',
  "Search school, team or code": "搜尋學校、小組或代碼",
  "Enter your teacher's code, then sign in with Google / Gmail to join your school team.": "先輸入導師派發的代碼，再用 Google / Gmail 登入，就可以加入所屬學校小組。",
  "Enter the 6-digit code from your teacher before signing in.": "請先輸入導師派發的六位數代碼，再登入。",
  "Your browser could not keep the team code. Allow website storage and try again.": "瀏覽器未能保存小組代碼，請允許此網站使用儲存空間，再試一次。",
  "Use a student Google / Gmail account for this team code.": "請用學生的 Google / Gmail 帳戶登入這個小組代碼。",
  'simulation': 'ATC simulation',
  'reconnecting': '恢復 voice 連線中…',
  'ATC simulation': 'ATC simulation',
  'Read back, clarify & keep talking': 'Readback、澄清同持續通話',
  'Waiting for Pilot — tap Talk': '等緊 Pilot 回覆 — 按 Talk',
  'ATC transmitting — listen': 'ATC 發話中 — 請聆聽',
  'Microphone on — tap Stop & send': '咪高峰已開 — 講完按 Stop & send',
  'Waiting for ATC reply…': '等緊 ATC 回覆…',
  'Keep the radio conversation going. Read back, or ask Say again / Confirm runway. Tap Stop & send after each call.': '可以持續輪流通話。做 readback，或者講 Say again / Confirm runway。每次講完按 Stop & send。',
  'Readback complete. You can keep talking, or choose Next radio call when ready.': 'Readback 已完成。可以繼續通話，準備好就按 Next radio call。',

  '3. Choose how to answer': '3. 揀作答方式',
  'Record your answer': '錄低你嘅回答',
  'Speak, replay & check phrases': '講、重聽、核對 phrases',
  'Talk to Tower': '同 Tower 通話',
  'Live English conversation': '即時 English 通話',
  'Record your English answer, then check your phrases.': '用 English 錄低回答，再核對 phrases。',
  'Opening microphone…': '開啟咪高峰中…',
  'Preparing recording…': '準備錄音中…',
  'Recording · {seconds}s / 60s': '錄音中 · {seconds} 秒 / 60 秒',
  'Stop recording': '停止錄音',
  'Record again': '再錄一次',
  'Listen to your answer': '重聽你嘅回答',
  'Listen to your answer · {seconds}s': '重聽你嘅回答 · {seconds} 秒',
  'Check my recording': '核對錄音回答',
  'Listening & checking…': '聆聽及核對中…',
  'What we heard': '辨認到嘅回答',
  'Small slips accepted:': '已接受嘅小誤差：',
  'Phrase checklist': 'Phrase 核對清單',
  'Sign in to record your voice and get feedback.': '登入後就可以錄音作答，睇返 phrase 核對結果。',
  'Recording is unavailable in this browser. Try Safari or Chrome.': '呢個瀏覽器未能錄音，請用 Safari 或 Chrome。',
  'Record a short answer and try again.': '請錄低一段簡短回答，再試一次。',
  'Your recording could not be checked. Please record it again.': '未能核對呢段錄音，請再錄一次。',
  'Voice checking is temporarily unavailable. Please try again.': '語音核對暫時未能使用，請稍後再試。',
  'Speak English only. Please record your answer again.': '請只用 English 作答，再錄一次。',
  'Your voice was not clear enough. Please record your answer again.': '未能聽清楚，請再錄一次。',
  'Your recording is still being checked. Please wait and retry.': '呢段錄音仲核對緊，請稍等再試。',
  'Please wait a minute before checking another recording.': '請等一分鐘，再核對另一段錄音。',
  'This recording ID has already been used. Record your answer again.': '請重新錄低回答，再提交。',
  "Signing you in…": "正在登入…",
  "Please wait while we get your account ready.": "正在準備你的帳戶，請稍候。",
  "Use your Google / Gmail account.": "請用你的 Google / Gmail 帳戶登入。",
  "Sign in with your Google account to join a team.": "請先用 Google 帳戶登入，再加入小組。",
  "Join your team": "加入你的小組",
  "Enter the code from your teacher.": "輸入導師派發的小組代碼。",
  "Join team": "加入小組",
  "Change team": "更換小組",
  "Create team": "建立小組",
  "Edit team": "編輯小組",
  "School name": "學校名稱",
  "Team name": "小組名稱",
  "Notes (optional)": "備註（選填）",
  "Save team": "保存小組",
  "Saving…": "正在保存…",
  "Teams": "小組",
  "Schools": "學校",
  "Participants": "參加者",
  "Search school or team": "搜尋學校或小組",
  "Create your first team to get started.": "先建立一個小組，再派發代碼俾學生。",
  "No matching teams.": "沒有符合搜尋的小組。",
  "{count} participants": "{count} 位參加者",
  "Edit": "編輯",
  "Students appear here after joining with Google.": "學生用 Google 登入並加入小組後，會顯示在這裡。",
  "All participants": "全部參加者",
  "No practice records yet.": "暫時未有練習紀錄。",
  "The access code is invalid or paused.": "代碼無效或小組已暫停，請向導師確認。",
  "Too many code attempts. Try again in 15 minutes.": "輸入錯誤次數太多，請等 15 分鐘後再試。",
  "Retry pending saves before changing team.": "請先重試保存未完成的練習，再更換小組。",
  "Join this session team before continuing the practice.": "請先加入這次練習原本的小組，再繼續練習。",
  "Invalid school name.": "請填寫學校名稱。",
  "Invalid team name.": "請填寫小組名稱。",
  "Invalid team notes.": "備註最多 600 個字。",
  'Sign in with your @creatogether.app Google account.': '請用你的 @creatogether.app 公司 Google 帳戶登入。',
  'Sign in with Google': '使用 Google 登入',
  'Checking your account…': '正在核對帳戶…',
  'Open Google sign-in window': '改用 Google 彈出視窗登入',
  'Usage manual': '使用手冊',
  'Release notes': '更新紀錄',
  'Use your @creatogether.app Google account to open Admin.': '請選擇 @creatogether.app 公司 Google 帳戶，才可以進入 Admin。',
  'Google sign-in was cancelled. Please try again.': 'Google 登入已取消，請再試一次。',
  'Allow pop-ups for this website, then try again.': '請允許此網站開啟彈出視窗，再試一次。',
  'This Google account cannot sign in yet. Contact your workshop organiser.': '此 Google 帳戶暫時未能登入，請聯絡工作坊負責人。',
  'Code copied.': '代碼已複製。',
  'Replace {team} access code?': '更換 {team} 的登入代碼？',
  'The old code will stop working. Students must sign in again with the new code. Their records will stay saved.': '舊代碼會失效，學生要用新代碼重新登入。他們的紀錄會保留。',
  'Cancel': '取消',
  'Replace code': '更換代碼',

  'Pilot phrase practice': 'Pilot 英語通話練習',
  'Listen to ATC. Read back in English.': '聆聽 ATC 指令，用 English 覆誦。',
  'Sign in': '登入',
  'Sign-in is temporarily unavailable. Please try again later.': '暫時無法登入，請稍後再試。',
  'Try without signing in': '先試一次',
  'Try typing a reply. Your practice will not be saved.': '試用文字作答，這次練習不會保存。',
  'Try-out · unsaved': '試用 · 不會保存',
  'Choose your practice': '選擇練習',
  'Type your reply': '輸入你的覆誦',
  'Voice practice': '語音練習',
  'Speak to ATC': '與 ATC 通話',
  'Speak English only.': '請只用 English 作答。',
  'Try a new set': '換一組練習',
  'New practice ready.': '新練習已準備好。',
  'Sign in to use voice practice and new sets.': '登入後可使用語音練習及新台詞。',
  'New set': '新台詞',
  'Standard set': '基本台詞',
  'Not saved': '不會保存',
  'Saved': '已保存',
  'Tap for hints': '點選查看提示',
  'Connect voice': '開始語音',
  'Connect, then tap Talk. Speak English and tap Stop when finished.': '點選「開始語音」，再點選「與 ATC 通話」。用 English 作答，說完後按「停止並送出」。',
  'Try-out complete. This practice was not saved.': '試用已完成，這次練習沒有保存。',
  'Your practice has been saved.': '你的練習已保存。',
  'Correct. Keep going.': '正確，繼續下一句。',
  'Check the highlighted parts and try again.': '請修正下面的部分，再試一次。',
  'Check your connection and try again.': '請檢查網絡連線後再試。',
  'Allow microphone access in your browser, then try again.': '請允許瀏覽器使用咪高峰，再試一次。',
  'No microphone was found. Check your microphone and try again.': '找不到咪高峰，請檢查後再試。',
  'Please sign in again to continue.': '請重新登入後繼續。',
  'Something went wrong. Please try again.': '暫時未能完成，請再試一次。',
  'Student team': '學生小組', 'Admin': 'Admin 管理', 
  'Manage your workshop': '管理你的工作坊',
  'Your name': '你的姓名', 'Student ID': '學生 ID', 'e.g. Jamie Chan': '例如：Jamie Chan',
  'Your school or workshop ID': '你的學校或工作坊 ID', 'Team access code': '小組登入代碼', 'Admin access code': 'Admin 登入代碼',
  '6 digits': '六位數字', 'Checking access…': '正在核對代碼…', 'Enter the cockpit': '進入練習', 'Open admin': '開啟管理介面',
  'WORKSHOP ADMIN': '工作坊管理', '40 teams. One flight deck.': '40 個小組，一個管理介面。',
  'Stable team codes and saved practice records.': '管理固定小組代碼和已保存的練習紀錄。', 'Refresh': '重新整理',
  'Team access': '小組登入管理', 'Team': '小組', 'Code': '代碼', 'Access': '狀態', 'Manage': '管理',
  'Copy {team} code': '複製 {team} 代碼', 'Active': '啟用中', 'Paused': '已暫停', 'Pause': '暫停', 'Restore': '恢復', 'New code': '產生新代碼',
  'Pause is reversible. New code revokes the previous code; team records remain available.': '可以恢復已暫停的小組。產生新代碼後，舊代碼會失效，小組紀錄會保留。',
  'Practice records': '練習紀錄', 'Choose a team to inspect their saved sessions.': '選擇一個小組，查看已保存的練習。',
  'Session transcript': '本次通話紀錄', 'Workshop admin': '工作坊 Admin', 
  'Sign out': '登出', 
  'Saved flights': '已保存練習', '1. Choose your group': '1. 選擇你的組別',
  'Primary': '小學', 'Junior Secondary': '初中', 'Senior Secondary': '高中',
  '{stages} stages · {turns} pilot calls': '{stages} 個階段 · {turns} 次 Pilot 通話',
  'Waypoint': '航路點', 'Landing runway': '降落跑道', 'Practice branch': '練習情境',
  'Basic circuit · 5 stages': '基本飛行 · 5 個階段', 'Manual heading correction': '手動設定航向修正',
  'Brake Failure · Pilot starts': 'Brake Failure · Pilot 先開始', 'Flap Failure · Pilot starts': 'Flap Failure · Pilot 先開始',
  'Turn': '轉彎方向', 'Heading': '航向', '2. Pick your practice style': '2. 選擇練習方式',
  'Tutorial': '教學模式', 'Phrase guide + explanations': '台詞提示及說明', 'Competition': '挑戰模式', 'Try your readback first': '先自行覆誦作答',
  'Typed rehearsal': '文字練習', 
  'FIRST PILOT CALL': '第一句 Pilot 台詞', 'Preparing…': '正在準備…', 
  'Use original': '使用原有教材',
  'Start practice': '開始練習', 'Pause & save': '暫停並保存',
  '{count} pending saves': '{count} 項待保存', '{count} not saved': '{count} 項未能保存', 'YOUR CIRCUIT': '目前飛行位置',
  'Circuit position: {stage}': '飛行位置：{stage}',
  'Aircraft circuit map': '飛行位置圖', 'CALLSIGN': '呼號', 'TAKEOFF': '起飛', 'LANDING': '降落', 'DEPARTURE': '離場頻率',
  'WAYPOINT': '航路點', 'ALTITUDE VALUE': '高度', 'CALL {current} OF {total}': '第 {current} / {total} 次通話',
  'Waits for your call': '等待你的通話', 'ATC starts': 'ATC 先開始', 'YOUR NEXT CALL': '你的下一句通話',
  'You start this turn. Report the emergency using the information below.': '這一輪由你先開始。請用 English，根據下方資料報告緊急情況。',
  'Pilot phrase': 'Pilot 台詞', 
  'Your readback': '你的 English 覆誦', 'Type the phrase you would say on the radio…': '請用 English 輸入你的通話台詞…',
  'Saving & checking…': '正在保存及評核…', 'Correct readback': '覆誦正確', 'Check readback': '評核覆誦',
  'Reconnect this turn': '重新連接這一輪', 'Stop & send': '停止並送出', 'Talk to tower': '與 ATC 通話', 'End voice': '結束語音',
  'INSTRUCTOR': '導師回饋', 'Not assessed': '尚未評核', 'Correct': '正確', 'Try again': '請再試一次',
  'Retry {count} pending saves': '重試保存 {count} 項紀錄', 'Finish & save flight': '完成並保存練習', 'Next radio call': '下一句通話',
  'Session transcript · {count} messages': '本次通話紀錄 · {count} 則', 
  'System': '系統',
  'Flight deck': '練習主頁', 'Your practice history': '你的練習紀錄',
  'No saved sessions yet. Start your first flight.': '尚未有已保存練習，開始你的第一次練習吧。',
  'CIRCUIT COMPLETE': '練習完成', 'Good readback, pilot.': 'Pilot，你已完成覆誦練習。',
  'You completed {count} radio calls.': '你已完成 {count} 次通話。',
  'Back to flight deck': '返回練習主頁', 'Review this flight': '重溫這次練習',
  'Pending': '待確認',
  'active': '進行中', 'paused': '已暫停', 'ended': '已結束', 'completed': '已完成',
  'correct': '正確', 'retry': '需重試', 'unavailable': '尚未評核',
  'primary': '小學', 'junior': '初中', 'senior': '高中', 'tutorial': '教學模式', 'competition': '挑戰模式', 'text': '文字練習', 'gemini-live': 'Gemini Live',
  'idle': '未連接', 'connecting': '連接中', 'connected': '已連接', 'listening': '收音中', 'processing': '處理中', 'speaking': 'ATC 播放中', 'disconnected': '已斷線', 'error': '連接失敗',
  'Aircraft callsign': '飛機呼號', 'Runway number and side': '跑道編號及方向', 'Radio frequency': '無線電頻率',
  'Altitude': '高度', 'Turn direction': '轉彎方向', 'Only required flight information': '只包含所需飛行資料',
  'Instruction meaning': '指令意思', 'No conflicting instruction': '沒有互相矛盾的指令', 'No conflicting numbers': '沒有互相矛盾的數字',
  'Training phrase order': '練習句序', 'Transcript available': '有可用通話紀錄', 'Fixed ATC training line': '固定 ATC 台詞',
  'Takeoff clearance': '起飛許可', 'Landing clearance': '降落許可', 'Departure contact instruction': '離場聯絡指令',
  'Tower address': '呼叫 Tower', 'Downwind and landing intent': '下風邊位置及降落意圖', 'Approach instruction': '進場指令',
  'Direct waypoint instruction': '直飛航路點指令', 'Maintain instruction': '保持高度指令', 'Visual approach clearance': '目視進場許可',
  'Urgency call three times': '三次緊急呼叫', 'Approach position': '進場位置', 'Emergency condition': '緊急情況',
  'Landing and rollout intention': '降落及滑跑意圖', 'No-flap landing intention': '無襟翼降落意圖', 'Full runway request': '全長跑道要求',
  'Turn instruction': '轉彎指令', 'Heading instruction': '航向指令',
  'Correct readback. All required fields and the phrase order match this training script.': '覆誦正確，所有所需資料及句序都符合這次練習台詞。',
  'The service is unavailable. Please retry.': '服務暫時無法使用，請重試。',
  'Connection lost. Pending transcripts stay in the delivery queue. Reconnect and retry saving before moving on.': '連線已中斷。請檢查網絡，重試保存後再繼續。',
  'The tower transcript differed from the fixed script. No result was accepted. Reconnect this turn.': 'ATC 通話與固定台詞不符，這次結果未獲接受。請重新連接這一輪。',
  'A complete matching tower transmission is required before this voice attempt can count. Reconnect to retry.': '需要收到完整、符合固定台詞的 ATC 通話，才可評核。請重新連接再試。',
  'The attempt has not been assessed. Retry saving to continue.': '這次作答尚未評核，請重試保存後繼續。',
  'Tower script mismatch. This attempt will not count; reconnect to retry the fixed script.': 'ATC 台詞不符，這次作答不會計算。請重新連接，再試固定台詞。',
  'Save a correct attempt before moving on.': '請先保存正確作答，再繼續下一輪。',
  'Some transcripts still need saving. Retry saving before moving on.': '部分通話紀錄尚未保存，請先重試保存再繼續。',
  'Some transcripts still need saving. Retry saving before leaving this session.': '部分通話紀錄尚未保存，請先重試保存再離開。',
  'Choose a heading from 1 to 360.': '請選擇 1 至 360 的航向。',
  'The access code is invalid or paused.': '登入代碼無效，或小組已被暫停。',
  'Too many code attempts. Try again in 15 minutes.': '嘗試代碼次數過多，請在 15 分鐘後再試。',
  'This team code has been paused or reset. Sign in with the current code.': '這個小組代碼已暫停或重設，請使用最新代碼登入。',
  'This team code has been paused or reset. Sign in again.': '這個小組代碼已暫停或重設，請重新登入。',
  'Voice could not continue. Reconnect or use typed practice.': '語音暫時無法繼續，請重新連接或使用文字練習。',
  'Voice connection could not start. Saved practice is intact; retry or use text practice.': '語音暫時無法啟動，已保存的練習會保留。請重試或使用文字練習。',
  'Voice connection timed out. Please reconnect.': '語音連接逾時，請重新連接。',
  'Microphone requires HTTPS and browser permission.': '請允許瀏覽器使用咪高峰，再試一次。',
  'No usable transcript was received. Please try this turn again.': '未收到可用的通話紀錄，請再試這一輪。',
  'An added negative or cancellation changes the instruction. Retry without changing its meaning.': '加入否定或取消字眼會改變指令意思，請保持原意再試。',
  'Remove the extra clearance or movement instruction. Read back only the displayed training instruction.': '請移除額外的許可或移動指令，只覆誦畫面上的練習指令。',

  'Callsign': '呼號', 'Practice callsign': '練習呼號', 'Competition callsign': '比賽呼號', 'Full flight · 5 stages + optional calls': '完整飛行 · 5 個階段 + 選用通話',
  'Heading correction (if needed)': '航向修正（如有需要）', 'OPTIONAL CALL': '選用通話', 'Optional': '選用', 'Emergency': '緊急', 'Jump to a call': '跳到指定通話',
  'Skip this call': '跳過呢句通話', 'Skip & finish flight': '跳過並完成練習', 'Microphone on — speak now': '咪高峰已開 — 請講',
  'Listening — pause 2 seconds to send': '收音中 — 停 2 秒自動送出', 'Auto mic: opens after ATC and sends after a 2-second pause': '自動咪：ATC 講完自動開咪，停 2 秒自動送出',
  'After ATC finishes, the microphone opens by itself. Speak, then pause for 2 seconds to send — or tap Stop & send.': 'ATC 講完會自動開咪。講完停 2 秒會自動送出，或者按「停止並送出」。',
  'You cleared {cleared} of {total} radio calls.': '你完成咗 {cleared} / {total} 句通話。', '{count} skipped': '跳過咗 {count} 句', 'armed': '咪高峰已開',
  'Complete this readback before advancing one turn.': '請先完成呢句覆誦，或者按「跳過呢句通話」。', 'Complete all scenario turns first.': '請先完成通話，或者按「跳過並完成練習」。',
  'Move to a call or finish the flight, not both.': '請揀跳去另一句通話，或者完成練習。', 'This session has ended.': '呢次練習已經結束。',
  'Invalid saved scenario position.': '揀咗嘅通話位置無效，請再試。', 'Too many voice requests. Wait a minute.': '語音連線次數太多，請等一分鐘再試。',
  'No completed voice response arrived. Your partial transcript was retained; reconnect to retry.': '等唔到 ATC 回覆。通話紀錄已保留，請按「重新連接這一輪」。',
  'Voice disconnected. Reconnect to retry this stage.': '語音已斷線，請重新連接這一輪。', 'Voice disconnected. Reconnect to continue.': '語音已斷線，請重新連接。',
  'Practice moved to another turn. Reconnect to continue.': '練習已轉到另一句通話，請重新連接。', 'Voice is idle. Reconnect to continue.': '語音閒置太耐，請重新連接。',
  'Voice session expired. Reconnect to continue.': '語音連線已過期，請重新連接。',
  'The voice provider disconnected. Saved practice is intact.': '語音服務中斷，已保存嘅練習會保留。', 'Voice provider disconnected.': '語音服務中斷。',
  'Cloud voice network connection failed.': '語音網絡連線失敗，請檢查網絡再試。', 'Cloud voice disconnected.': '語音連線已中斷。',
  'Voice is ending. Please wait before reconnecting.': '語音結束緊，請稍等再重新連接。', 'Generated scenario not found.': '搵唔到呢組新台詞，請再按「換一組練習」。',
  'Choose the practice or competition callsign.': '請揀練習或者比賽呼號。', 'Cleared {count}': '已完成 {count} 句', 'Skipped: {list}': '跳過：{list}',
  'Callsign: {callsign}': '呼號：{callsign}',
  'Your first Pilot call stays hidden until you answer.': '第一句 Pilot 台詞會喺你作答之後先顯示。', 'This readback did not count. Reconnect this turn to retry.': '呢次覆誦未計算，請重新連接呢一輪再試。',
  'You completed 1 radio call.': '你已完成 1 次通話。', 'Ten variants per hour are allowed. Use a saved variant or the original template.': '每小時最多準備 10 組新台詞，請用已準備嘅新台詞或者原有教材。',
  'A validated practice script could not be generated. No new scenario was saved. Please retry later.': '暫時未能準備新台詞，請稍後再試，或者用原有教材。', 'Voice authorization timed out.': '語音授權逾時，請重新連接。',
  'Voice connection was cancelled.': '語音連線已取消。', 'The cloud voice connection is not ready.': '語音連線未準備好，請稍等再試。',
  'Return to the saved current turn before submitting.': '請返回目前嗰句通話再提交。', 'The saved scenario is unavailable. Start a new practice session.': '搵唔到呢次練習嘅台詞，請重新開始練習。',
  'Microphone did not finish its audio frame. Please reconnect.': '咪高峰未完成收音，請重新連接。', 'Report only the displayed emergency.': '只報告畫面顯示嘅緊急情況。',
  'Only the reported emergency': '只報告指定緊急情況', 'Instructor': '導師', 'Tower': 'Tower', 'Approach': 'Approach', 'ATC': 'ATC',
  'This team code was paused or reset. Sign in again.': '這個小組代碼已暫停或重設，請重新登入。', 'Team membership changed. Sign in again.': '小組資格已更改，請重新登入。',
};
const fill = (text, values) => text.replace(/\{(\w+)\}/g, (match, key) => values[key] ?? match);
export function readUiLanguage(storage) {
  try { const value = (storage ?? globalThis.localStorage)?.getItem(UI_LANGUAGE_KEY); return SUPPORTED_LANGUAGES.includes(value) ? value : 'en'; } catch { return 'en'; }
}
export function persistUiLanguage(language, storage) {
  if (!SUPPORTED_LANGUAGES.includes(language)) return false;
  try { (storage ?? globalThis.localStorage)?.setItem(UI_LANGUAGE_KEY, language); return true; } catch { return false; }
}
export function createTranslator(language) {
  const chinese = language === 'zh-Hant';
  const t = (key, values = {}) => fill(chinese ? zh[key] ?? key : key, values);
  t.message = text => {
    if (!text) return '';
    // Current callable SDK appends HTTP status codes to otherwise useful messages.
    text = String(text).replace(/\s+\[\d{3}\]$/, '');
    if (text === 'Microphone requires HTTPS and browser permission.') return t('Allow microphone access in your browser, then try again.');
    if (text === 'Connection lost. Pending transcripts stay in the delivery queue. Reconnect and retry saving before moving on.') return t('Check your connection and try again.');
    if (zh[text]) return t(text);
    if (/network|offline|failed to fetch/i.test(text)) return t('Check your connection and try again.');
    if (/NotFoundError|no.*microphone|device.*not found/i.test(text)) return t('No microphone was found. Check your microphone and try again.');
    if (/NotAllowedError|microphone|audio.*permission/i.test(text)) return t('Allow microphone access in your browser, then try again.');
    if (/unauthenticated|permission.denied|auth\/|sign.in/i.test(text)) return t('Please sign in again to continue.');
    // Unknown service diagnostics never belong in the student interface.
    return t('Something went wrong. Please try again.');
  };
  t.criterion = criterion => {
    if (!chinese) return criterion.feedback || `Expected ${criterion.expected}`;
    if (['callsign', 'runway', 'frequency', 'altitude', 'waypoint', 'direction', 'heading'].includes(criterion.id)) return `請準確覆誦${t(criterion.label)}「${criterion.expected}」。`;
    if (criterion.id === 'phrase-order') return '請依照畫面上 English 練習台詞的句序覆誦。';
    if (criterion.id === 'number-conflict') return `請移除或更正矛盾數字，這句台詞的數字是「${criterion.expected}」。`;
    if (criterion.id === 'field-conflict') return '請移除額外飛行資料，只使用畫面上的 English 練習台詞。';
    if (['polarity', 'instruction-conflict', 'transcript', 'emergency-conflict'].includes(criterion.id)) return t.message(criterion.feedback);
    return `請按照練習台詞讀出「${criterion.expected}」。`;
  };
  t.assessment = evaluation => {
    if (evaluation.correct) return t('Correct. Keep going.');
    if (evaluation.status === 'unavailable') return t.message(evaluation.feedback);
    if (evaluation.criteria?.some(c => !c.passed)) return t('Check the highlighted parts and try again.');
    return t.message(evaluation.feedback);
  };
  return t;
}
